import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: var(--lumen-spacing-8);
  padding: var(--lumen-padding-16) var(--lumen-padding-12);
`

export const Illustration = styled.div`
  display: block;
  width: 180px;
  max-width: 100%;

  > svg {
    display: block;
    width: 100%;
    height: auto;
  }
`
